import { Markdown as MarkdownBase } from '@design/components/markdown';
import { Tracking } from '@terminal/services/tracking';
import { useFlags } from '@terminal/stores/use-flags/useFlags';
import { Components, Options } from 'react-markdown';

export interface MarkdownProps {
  message: string;
  onLoad?: (element: HTMLDivElement) => void;
  components?: Partial<Components>;
  remarkPlugins?: Options['remarkPlugins'];
  rehypePlugins?: Options['rehypePlugins'];
  isDark?: boolean;
}

export const Markdown = ({
  message,
  onLoad,
  components,
  remarkPlugins,
  rehypePlugins,
  isDark = true,
}: MarkdownProps) => {
  const wrapTableCells = useFlags(state =>
    state.getFeatureFlagState('REASON-2724-wrap-markdown-table-cells')
  );

  const logError = (error: unknown) => {
    if (error instanceof Error) {
      Tracking.captureException(error);
    }
  };

  return (
    <MarkdownBase
      message={message}
      onLoad={onLoad}
      components={components}
      remarkPlugins={remarkPlugins}
      rehypePlugins={rehypePlugins}
      onError={logError}
      isDark={isDark}
      wrapTableCells={wrapTableCells}
    />
  );
};
